import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
/*
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireObject, AngularFireDatabase } from 'angularfire2/database';
*/
import { ActivatedRoute, Router } from '@angular/router';
import { AwsService } from '../../providers/appsyncservice/aws.service';

@Component({
  selector: 'app-alertbox',
  templateUrl: './alertbox.component.html',
  styleUrls: ['./alertbox.component.css']
})
export class AlertboxComponent implements OnInit {


  alertJson: any;
  alertList: Observable<any>;
  sosName: any;
  s_sosname: any;
  formatedUser = [];
  getseverity: any;
  alertType: any;
  allusers: any;
  getusername: any;
  alerts: any;
  alerttypes: any;
  theevent: any
  now: any
  hours: any
  minutes: any


  _MS_PER_DAY = 1000 * 60 * 60 * 24;

  constructor(public awserviceProvider: AwsService, private route: ActivatedRoute, public router: Router) {

    this.alertBoxTrigger();
    this.awserviceProvider.getScSosMaster().then(types => {
      this.alerttypes = types;
    });

  }

  ngOnInit() {
    this.alerts = [];
    this.alerttypes = [];
  }

  alertBoxTrigger() {
    this.awserviceProvider.getOpenSos().then(sosdata => {
      sosdata.forEach(sos => {
        this.sosHours(sos);
        let types = this.alerttypes.filter(type => {
          if (parseInt(type.id) == sos.severity) {
            return type
          }
        }
        )
        sos.type = types[0];
        console.log(" sos.type", sos.type)
        this.alerts.push(sos);

      })
      this.alerts.sort();
    })
  }



  getAlertType(st): any {

    // getScSosMaster


    if (st === 1) {
      this.alertType = "Injury/Accident";
    }
    else if (st === 2) {
      this.alertType = "Medical Assistance";
    }
    else if (st === 3) {
      this.alertType = "Vehicle Break down";
    }
    else if (st === 4) {
      this.alertType = "Suspicious Route";
    }
    else if (st === 5) {
      this.alertType = "Rash Driving";
    }
    else if (st === 6) {
      this.alertType = "Misconduct";
    }
    return this.alertType;
  }




  // a and b are javascript Date objects
  dateDiffInDays(a, b) {
    // Discard the time and time-zone information.
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return Math.floor((utc2 - utc1) / this._MS_PER_DAY);

  }


  sosHours(sos) {
    var sosDate = new Date(sos.created_at);
    var today = new Date();

    var datetime = new Date(sosDate).getTime();
    var now = new Date(today).getTime();
    if (isNaN(datetime)) {
      return sos;
    }
    if (datetime < now) {
      var milisec_diff = now - datetime;
    } else {
      var milisec_diff = datetime - now;
    }
    var days = Math.floor(milisec_diff / 1000 / 60 / (60 * 24));
    var date_diff = new Date(milisec_diff);
    var msec = milisec_diff;
    var hh = Math.floor(msec / 1000 / 60 / 60);
    msec -= hh * 1000 * 60 * 60;
    var mm = Math.floor(msec / 1000 / 60);
    msec -= mm * 1000 * 60;
    var ss = Math.floor(msec / 1000);
    msec -= ss * 1000
    var daylabel = "";
    if (days > 1) {
      var grammar = " ";
      if (days > 1) grammar = "s "
      var hrreset = days * 24;
      hh = hh - hrreset;
      daylabel = days + " Day" + grammar;


    }
    //  Format Hours
    var hourtext = '00';
    hourtext = String(hh);
    if (hourtext.length == 1) { hourtext = '0' + hourtext };
    //  Format Minutes
    var mintext = '00';
    mintext = String(mm);
    if (mintext.length == 1) { mintext = '0' + mintext };

    //  Format Seconds
    var sectext = '00';
    sectext = String(ss);
    if (sectext.length == 1) { sectext = '0' + sectext };

    var msectext = '00';
    msectext = String(msec);
    msectext = msectext.substring(0, 1);
    if (msectext.length == 1) { msectext = '0' + msectext };
    sos.time_ago = daylabel + hourtext + ":" + mintext + ":" + sectext;
    console.log("SOS", sos);
    return sos//+ ":" + msectext;}

  }


}
